









import { Component, Vue } from 'vue-property-decorator'
import config from '@/config'
import Yasgui from '@triply/yasgui'
import '@triply/yasgui/build/yasgui.min.css'

@Component
export default class Query extends Vue {
  private yasgui: Yasgui | null = null

  beforeCreate() {
    Yasgui.Yasqe.defaults.prefixCcApi = `${config.publicPath}/prefix.json`
    Yasgui.Yasqe.defaults.value = `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX dcat: <http://www.w3.org/ns/dcat#>
PREFIX healthdcatap: <http://healthdataportal.eu/ns/health#>
PREFIX sphn-metacat: <https://biomedit.ch/rdf/sphn-metacat/sphn/>
PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX void: <http://rdfs.org/ns/void#>

SELECT * WHERE {
  ?s a dcat:Catalog .
  ?s dcterms:title ?title .
}
`
  }

  mounted() {
    this.yasgui = new Yasgui(this.$refs.yasgui as HTMLElement, {
      requestConfig: {
        endpoint: config.sparqlEndpointURL,
      },
      copyEndpointOnNewTab: false,
    })
  }

  beforeDestroy() {
    this.yasgui = null
  }
}
